import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
}

function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/blogs/manifest.json`)
      .then(res => res.json())
      .then(data => {
        setPosts(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return <p className="status-text">Loading...</p>;
  }

  if (posts.length === 0) {
    return <p className="status-text">Nothing here yet.</p>;
  }

  return (
    <ul className="post-list">
      {posts.map(post => (
        <li key={post.slug}>
          <Link to={`/blog/${post.slug}`} className="post-list-row">
            {post.date && (
              <time className="post-list-date">{formatDate(post.date)}</time>
            )}
            <span className="post-list-title">{post.title}</span>
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default BlogList;
